export default "__VITE_ASSET__f3349848__"